module.exports = {"top3":["Hospital admissions for pediatric asthma","Medicare spending per beneficiary","Skilled nursing facility patients with a hospital readmission"],"bottom3":["Children without all recommended vaccines","Alcohol deaths","Suicide deaths"],"most_improved":["Uninsured children","Home health patients without improved mobility","Adults with inappropriate lower back imaging"],"most_declined":["Suicide deaths","Preventable hospitalizations ages 18-64","Hospital 30-day mortality"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/MT.json
// module id = 266
// module chunks = 143196823979170 184088790168614